import { render, staticRenderFns } from "./MarketSidebar.vue?vue&type=template&id=81f91662&"
import script from "./MarketSidebar.vue?vue&type=script&lang=js&"
export * from "./MarketSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports